import {
  GET_PAX_INNER_REQ,
  GET_PAX_INNER_RES,
  GET_PAX_REQ,
  GET_PAX_RES,
  // ##### Komarov 2025-07-19
  SET_COUNTER_ADULTS,
  SET_COUNTER_CHILD,
  SET_COUNTER_ROOMS,
  SET_PAX_LIST_OPEN,
  SET_IS_ON_MODAL_DIV,
} from '../constants';

//action creator
const paxResponse = res => ({
  type: GET_PAX_RES,
  payload: res,
});

// console.log('[CONTENTRESPONCE]' , contentResponse)
// ##### 24-03-21 Komarov
export const getPax = (adults, children, rooms) => dispatch => {
  // console.log('GET_PAX1:', getState())
  dispatch({ type: GET_PAX_REQ });

  // const test = getState().paxchoice.pax

  const newObject = {
    adults: adults,
    children: children,
    // infants: infants,
    rooms: rooms,
  };

  dispatch(paxResponse(newObject));
  // console.log('GET_PAX4', newObject)
};

//action creator
const paxResponseInnerSearch = res => ({
  type: GET_PAX_INNER_RES,
  payload: res,
});

// console.log('[CONTENTRESPONCE]' , contentResponse)
// ##### 24-03-21 Komarov
export const getPaxInnerSearch = (adults, children, rooms) => dispatch => {
  // console.log('GET_PAX1:', getState())
  dispatch({ type: GET_PAX_INNER_REQ });

  // const test = getState().paxchoice.pax

  const newObject = {
    adults: adults,
    children: children,
    // infants: infants,
    rooms: rooms,
  };

  dispatch(paxResponseInnerSearch(newObject));
  // console.log('GET_PAX4', newObject)
};

// ##### Komarov 2025-07-19
export const setCounterAdults = payload => dispatch => {
  dispatch({
    type: SET_COUNTER_ADULTS,
    payload,
  });
};

export const setCounterChild = payload => dispatch => {
  dispatch({
    type: SET_COUNTER_CHILD,
    payload,
  });
};

export const setCounterRooms = payload => dispatch => {
  dispatch({
    type: SET_COUNTER_ROOMS,
    payload,
  });
};

export const setPaxListOpen = payload => dispatch => {
  dispatch({
    type: SET_PAX_LIST_OPEN,
    payload,
  });
};

export const setisOnModalDiv = payload => dispatch => {
  dispatch({
    type: SET_IS_ON_MODAL_DIV,
    payload,
  });
};
